<template>
<SideComponent @scrollto="scroll"></SideComponent>
	<div class="container" ref="viewBox">
		<Header2 :show-search-bar-pic="showHeader" login-style="loginStyle" :mobile-icon-style="mobileIconStyle" :show-list-icon="showListIcon"/>
		<div class="content">
			<div style="height:80px;"></div>
			<div class="enclosure">
				<div class="inner">
					<div class="left">
						<SideMenu />
					</div>
					<div class="right">
						<div class="caption">
							<span>{{$t('person.personCenter')}}</span><span class="arrow"><i class="iconfont icon-jiantou2"></i></span><span>{{$t('application.settled')}}</span>
						</div>
						
						<div class="tag-outer">
							
							<div class="settle-outer">
								<div class="tag-item">
									<div class="tip-text">
										{{$t('apply_info.tip1')}}
									</div>
								</div>
								<div style="border-top:2px solid rgb(207,207,207);width:100%;height:20px;"></div>
								
								<div class="head">
									<i class="iconfont icon-bianji4 edit"></i><span style="padding:0 10px;">{{$t('apply_info.tip2')}}</span>
								</div>

								<div class="verify-form">
									<el-form ref="ruleRef" :model="ruleUser" :rules="_rules" label-width="200px" :size="formSize" class="form-style" label-position="top">
										<el-form-item prop="user_type" :label="$t('form.user_type')">
										    <el-radio v-model="ruleUser.user_type" label="1"  disabled>{{$t('form.type1')}}</el-radio>
										    <el-radio v-model="ruleUser.user_type" label="2"  disabled>{{$t('form.type2')}}</el-radio>
										</el-form-item>
										<el-form-item prop="realname" :label="$t('form.realname')" v-if="ruleUser.user_type==1">
										    <el-input v-model="ruleUser.realname" :size="formSize" autocomplete="off" :placeholder="$t('form.enterRealname')" readonly></el-input>
										</el-form-item>
										<el-form-item prop="company" :label="$t('form.company')" v-if="ruleUser.user_type==2">
										    <el-input v-model="ruleUser.company" autocomplete="off" :placeholder="$t('form.enterCompany')" readonly></el-input>
										</el-form-item>
										<el-form-item prop="mobile" :label="$t('phoneNumber')">
										    <el-input v-model="ruleUser.mobile" autocomplete="off" :placeholder="$t('enterPhoneNumber')" readonly></el-input>
										</el-form-item>
										<el-form-item prop="email" :label="$t('form.email')">
										    <el-input v-model="ruleUser.email" autocomplete="off" :placeholder="$t('form.enterEmail')" readonly></el-input>
										</el-form-item>
										
										
										<el-form-item :label="$t('form.worktype')" prop="worktype">	
											<el-checkbox-group v-model="ruleUser.worktype">								    
											    <el-checkbox label="image" value="image" disabled>{{$t('form.image')}}</el-checkbox>
											    <el-checkbox label="video" value="video" disabled>{{$t('form.video')}}</el-checkbox>		
										    </el-checkbox-group>	
										</el-form-item>
										<el-form-item prop="contract" :label="$t('apply_info.bankcard')">
										    <div class="bank-card-row">
										    	<span>{{ bankcard || '-' }}</span>
										    	<el-button type="primary" link @click="openBankDialog">{{$t('apply_info.changeBankCardInfo')}}</el-button>
										    </div>
										</el-form-item>		
										<el-form-item prop="contract" :label="$t('apply_info.tip4')">
										    <a :href="pdfurl" class="view-contract" download v-if="pdfurl">{{$t('apply_info.tip3')}}</a>
										</el-form-item>										
										<!-- <el-form-item>
										    <el-button type="primary" class="el-button-1" @click="submitForm(ruleRef)">提交申请</el-button>	   
										</el-form-item> -->
									</el-form>
								</div>
							</div>
							
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog v-model="bankDialogVisible" :title="$t('apply_info.bankDialogTitle')" :width="isMobile ? '94%' : '640px'" class="bank-card-dialog">
			<el-form ref="bankFormRef" :model="bankForm" :rules="bankRules" label-position="top">
				<el-form-item prop="bank_card" :label="$t('form.bankcard')">
					<el-input v-model="bankForm.bank_card" autocomplete="off" :placeholder="$t('form.enter_bankcard')"></el-input>
				</el-form-item>
				<el-form-item :label="$t('form.bankcard_photo')" prop="bank_card_thumb" class="images">
					<div class="images-item btn-pic common">
						<Loading :is-loading="isBankUploadLoading"></Loading>
						<input type="file" id="bankcard_upload_update" @change="uploadBankCardFile($event)" accept="image/*" style="display:none;" />
						<label v-if="!bankForm.bank_card_thumb" for="bankcard_upload_update" class="upload-btn upload-click-area">
							<p class="upload-tiptext">{{$t('form.uploadPic')}}</p>
							<span class="upload-tip-desc">{{$t('form.bankcard_tip')}}</span>
						</label>
						<label v-if="bankForm.bank_card_thumb" for="bankcard_upload_update" class="upload-btn preview-click-area">
							<img class="bank-card-preview" :src="bankForm.bank_card_thumb" />
							<span class="preview-reupload-text">{{$t('form.uploadPic')}}</span>
						</label>
					</div>
				</el-form-item>
			</el-form>
			<template #footer>
				<div class="bank-dialog-footer">
					<el-button @click="bankDialogVisible = false">{{$t('apply_info.cancel')}}</el-button>
					<el-button type="primary" :loading="isBankSubmitLoading" :disabled="bankSubmitDisabled" @click="submitBankForm(bankFormRef)">{{$t('submitText')}}</el-button>
				</div>
			</template>
		</el-dialog>
		<Footer/>
	</div>
</template>

<script>
	import apply_info from './apply_info_controller';
	export default apply_info;
</script>

<style src="@/assets/css/my/grapher/apply_info.css" scoped> </style>
<style scoped>
.upload-click-area {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: calc(100% - 166px);
	min-height: 96px;
	padding: 12px 14px;
	border: 1px dashed rgb(230, 0, 15, 0.45);
	border-radius: 6px;
	background: rgb(250, 250, 250);
	cursor: pointer;
	transition: all 0.2s ease;
}

.upload-click-area:hover {
	border-color: rgb(230, 0, 15, 0.9);
	background: rgb(255, 247, 247);
}

.upload-tip-desc {
	color: rgb(113, 113, 113);
	font-size: 14px;
	padding-top: 8px;
}

.bank-card-preview {
	width: 150px;
	height: 150px;
	border-radius: 3px;
	border: 1px solid rgb(230, 0, 15, 0.5);
	background-color: rgb(252, 252, 252);
	object-fit: contain;
}

.preview-click-area {
	display: flex;
	flex-direction: column;
	align-items: center;
	cursor: pointer;
}

.preview-reupload-text {
	padding-top: 8px;
	font-size: 13px;
	color: rgb(113, 113, 113);
}

:deep(.bank-card-dialog .el-dialog__body) {
	padding: 20px 20px 10px;
}

@media screen and (max-width: 767px) {
	:deep(.bank-card-dialog .el-dialog) {
		margin-top: 5vh !important;
	}

	:deep(.bank-card-dialog .el-dialog__body) {
		padding: 14px 12px 8px;
	}

	:deep(.bank-card-dialog .el-form-item) {
		margin-bottom: 14px;
	}

	:deep(.bank-card-dialog .images-item.btn-pic.common) {
		flex-direction: column;
		align-items: stretch;
	}

	.upload-click-area {
		width: 100%;
		min-height: 110px;
		padding: 14px 12px;
	}

	.upload-tip-desc {
		font-size: 13px;
		line-height: 1.4;
		text-align: center;
	}

	.bank-card-preview {
		width: 120px;
		height: 120px;
		margin: 10px auto 0;
	}

	.bank-dialog-footer {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.bank-dialog-footer :deep(.el-button) {
		width: 100%;
		min-height: 40px;
		margin-left: 0;
	}
}
</style>